import React from 'react';
import PropTypes from 'prop-types';

import Container from '@Theme/hijunior/components/Container/Container';
import Breadcrumbs from '@Theme/hijunior/components/Breadcrumbs/Breadcrumbs';

import * as styles from './GenericHeading.module.scss';

const propTypes = {
  breadcrumbs: PropTypes.array,
  heading: PropTypes.string,
  description: PropTypes.string,
  variant: PropTypes.oneOf([
    'Category'
  ])
};

const GenericHeading = props => {
  const { breadcrumbs, heading, description, variant } = props;
  if (!heading) {
    return false;
  }

  return <section className={`${styles.root} ${variant ? styles[`root${variant}`] : ''}`}>
    <Container>
      {breadcrumbs && <Breadcrumbs items={breadcrumbs} classname={styles.rootBreadcrumbs} />}
      {heading && <h1 className={styles.rootHeading}>{ heading }</h1>}
      {description && <p className={styles.rootDescription}>{ description }</p>}
    </Container>
  </section>;
};

GenericHeading.propTypes = propTypes;

export default GenericHeading;
